import {CircularProgress, Container, IconButton, Table, TableBody, TableCell, TableContainer, TableRow, Tooltip,
} from "@mui/material";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import React, { ChangeEvent, useEffect, useMemo, useRef, useState } from "react";
import { wantedToBuySearchClient } from "../../typesenseAdapter.js";
import { Configure, Hits, InstantSearch, useHits, useInstantSearch } from "react-instantsearch";
import { useHistory, useParams } from "react-router";
import Cookies from "universal-cookie";
import "../../App.css";
import Constant from "../../Constant";
import { CommonService } from "../../Service/CommonService";
import { OrderApiService } from "../../Service/OrderApiService";
import WhiskyBarrelBig from "../../assets/images/products/WhiskyBarrelBig.png";
import "../Dynamic/ProductDetail.scss";
import CurrencyFormatter from "../Static/CurrencyFormatter";
import "../popups/CommonPopup.scss";
// import Spinner from "../Common/Spinner";
import { darken } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import CKContent from "../Common/CKcontent";
import { useRoute } from "../Common/route";
import { RootState } from "../store";
import { setMyCartItems, setProductName } from "../store/cartSlice";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ProductionQuantityLimitsOutlinedIcon from '@mui/icons-material/ProductionQuantityLimitsOutlined';
import { Service } from '../../Service/ApiService';
import EditIcon from '../../assets/images/icons/EditIcon.svg';

import barrel_1_2_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-1.png';
import barrel_2_3_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-2.png';
import barrel_3_4_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-3.png';
import barrel_4_5_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-4.png';
import barrel_5_6_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-5.png';
import barrel_6_7_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-6.png';
import barrel_7_8_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-7.png';
import barrel_8_9_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-8.png';
import barrel_9_10_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-9.png';
import barrel_10_11_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-10.png';
import barrel_11_12_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-11.png';
import barrel_12_13_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-12.png';
import barrel_13_14_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-13.png';
import barrel_14_15_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-14.png';
import barrel_15_16_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-15.png';
import barrel_16_17_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-16.png';
import barrel_17_18_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-17.png';
import barrel_18_19_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-18.png';
import barrel_19_20_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-19.png';
import barrel_20_21_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-20.png';
import barrel_21_22_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-21.png';
import barrel_22_23_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-22.png';
import barrel_23_24_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-23.png';
import barrel_24_25_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-24.png';
import barrel_25_plus_a from '../../assets/images/wanted_to_buy_images/WDTP-Age-25.png';

const useStyles = makeStyles({
  root: {
    boxShadow: "none",
  },
  firstColumn: {
    minWidth: 115,
    width: "max-content",
    borderBottom: "none",
    color: "#496673",
    fontSize: "14px",
    fontWeight: "700",
    backgroundColor: "transparent",
  },
  secondColumn: {
    width: "100%",
    borderBottom: "none",
    color: "#242424",
    backgroundColor: "transparent",
  },
});

type FormValue = {
  quantity: number;
  pricePerBarrel: number;
  comment: string;
  inventoryId: string;
  status: string;
  ownerStatus: string;
  handlingFee: number;
  serviceFee: number;
  totalAmount: number;
  inventoryName: string;
  isAccountTransfer: boolean;
  isRelocationRequired: boolean;
  isThirdPartyStorage: boolean;
  companyId: string;
};

const WantedToBuyProductDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [globalFilter, setGlobalFilter] = useState<string>("");
  const wantedToBuyCollectionName = process.env.REACT_APP_TYPESENSE_WANTED_TO_BUY_COLLECTIONNAME;

  useEffect(() => {
    // Scroll to top when the component mounts
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures this runs only once when the component mounts

  useEffect(() => {
    console.log("Added");
    const filters = [
      `id:${id}`,
      "is_active:=true",
      "is_delete:=false"
    ];

    // Generate dynamic filter string
    const filterValue = filters.join(",");
    setGlobalFilter(filterValue);
  }, []);

  if (!wantedToBuySearchClient) {
    return <div>Loading...</div>;
  }

  return (
    <InstantSearch searchClient={wantedToBuySearchClient} indexName={wantedToBuyCollectionName}>
      <Configure filters={globalFilter} />
      <CustomHits>
        <Hits hitComponent={HitItem} />
      </CustomHits>
    </InstantSearch>
  );
};

const HitItem: React.FC<{ hit: any }> = ({ hit }) => {
  const classes = useStyles();
  const [count, setCount] = React.useState(1);
  const [existingCount, setExistingCount] = React.useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isInWishlist, setIsInWishlist] = useState<boolean | null>(null);
  const [isOffer, setIsOffer] = useState<boolean | null>(false);
  const [isSample, setIsSample] = useState<boolean | null>(false);
  const [formData, setFormData] = useState<FormValue>({
    quantity: 0,
    pricePerBarrel: 0,
    comment: "",
    inventoryId: hit.id,
    status: "PENDING_REVIEW",
    ownerStatus: "ACTION_REQUIRED",
    handlingFee: 0,
    serviceFee: 0,
    totalAmount: 0,
    inventoryName: hit.product_name,
    isAccountTransfer: hit.is_account_transfer,
    isRelocationRequired: hit.is_relocation_required,
    isThirdPartyStorage: hit.is_third_party_storage,
    companyId: CommonService.getCompanyId()
  });

  const userId = new Cookies().get("userId");
  const [multipleBarrels, setMultipleBarrels] = useState<string>("");
  const [multiplelots, setMultiplelots] = useState<string>("");
  const [purpose, setPurpose] = useState<string>("");
  const [size, setSize] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [quantity, setQuantity] = useState<any>(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const [isInterested, setIsInterested] = useState(false);
  const route = useRoute();
  const [isExpanded, setIsExpanded] = useState(false);

  const validateSampleRequestFields = () => {
    //validate all the fields and set the error if have and return true of false 

    let isValid = true;
    let errors = {
      purpose: "",
      multipleBarrels: "",
      multipleLots: "",
      size: "",
      quantity: "",
      requestNote: ""
    };

    // Validate purpose
    if (!purpose || purpose.trim().length === 0) {
      errors.purpose = "Please enter your purpose";
      isValid = false;
    }

    // Validate multipleBarrels
    if (!multipleBarrels) {
      errors.multipleBarrels = "Multiple container are required";
      isValid = false;
    }

    // Validate multipleLots
    if (!multiplelots) {
      errors.multipleLots = "Multiple lots are required";
      isValid = false;
    }

    // Validate size
    if (!size) {
      errors.size = "Please enter size";
      isValid = false;
    }

    // Validate quantity
    if (!quantity || isNaN(quantity) || quantity <= 0) {
      errors.quantity = "Please enter quantity";
      isValid = false;
    }

    //Validate request note
    if (description.trim().length == 0) {
      errors.requestNote = "Please enter request note";
      isValid = false;

    }
    return isValid;
  }

  let orderItems: any;
  orderItems = {
    inventoryId: hit.inventory_id,
    inventoryTitle: hit.product_name,
    price: hit.price,
    quantity: count,
    totalPrice: hit.price * count,
    serviceFee: 0,
    handlingFee: 0,
    // handlingFee: hit.is_relocation_required == true ? count * 10 : 0,
    // serviceFee: (hit.is_account_transfer == true ? 10 : 0)+(hit.is_third_party_storage == true ? count*10 : 0),
    // serviceFee: Math.min(CommonService.isFacilityMatch(hit?.facility) ? 0 : (hit.is_account_transfer == true ? 10 * count : 0), 5000),
    isRelocationRequiredByOwner: hit.is_relocation_required,
    isAccountTransferByOwner: hit.is_account_transfer,
    isRelocationRequiredByBuyer: hit.is_relocation_required,
    isAccountTransferByBuyer: hit.is_account_transfer,
    isThirdPartyStorage: hit.is_third_party_storage,
    ownerOrderStatus: 'ACTION_REQUIRED',
    platformFee: hit.platform_fee,
    feeType: hit.fee_type,
    companyId: CommonService.getCompanyId(),
    inventoryOwner: hit.owner_name
  };

  const wishListRequest = {
    inventoryId: hit.inventory_id,
    userId: userId,
    inventoryTitle: hit.product_name,
  };

  useEffect(() => {
    dispatch(setProductName(hit.product_name));
    console.log("call use Effect");
    //isInventoryInWishlist();
    //isInventoryInCartForUser();
  }, []);

  const isInventoryInWishlist = async () => {
    try {
      const isInWishlistValue = await OrderApiService.isInventoryInWishlist(
        hit.inventory_id
      );
      setIsInWishlist(isInWishlistValue.data);
    } catch (error) {
      console.error("Error while fetching wishlist:", error);
    }
  };

  useEffect(() => {
    const checkStatus = async () => {
      const resp = await Service.checkMyInterest(hit?.id, userId);
      setIsInterested(resp.data === true);
    };
    checkStatus();
  }, []);
  const isInventoryInCartForUser = async () => {
    try {
      const orderItemsInCart : any = await OrderApiService.isInventoryInCartForUser(hit.inventory_id);
      console.log("Response for isInventoryInCartForUser:", orderItemsInCart.data);

      if (orderItemsInCart.data.length > 0) {
        console.log(true);
        setExistingCount(orderItemsInCart.data[0].quantity);
        setCount(orderItemsInCart.data[0].quantity);
      } else {
        console.log(false)
      }

    } catch (error) {
      console.error("Error while checking if inventory is in cart:", error);
    }
  };

  const manageWishList = async (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {

    // Restrict access to Super Admins and users belonging to the same company as the inventory
    if(CommonService.isAdmin() || CommonService.isSameCompany(hit?.company_id)) {
      return ;
    }

    if (isInWishlist) {
      const success = await removeFromWishList();
      if (success) {
        setIsInWishlist(false);
      }
    } else {
      const success = await addToWishList();
      if (success) {
        setIsInWishlist(true);
      }
    }
  };

  const addToWishList = async (): Promise<boolean> => {
    try {
      const response: any = await OrderApiService.addToWishlist(wishListRequest);
      return true;
    } catch (error) {
      console.error("Error while adding wishlist data:", error);

      if (error?.response?.data?.errorMessage === 'This inventory is no longer available in marketplace') {
        CommonService.Toast.fire({
          title: "This inventory is no longer available in Marketplace",
          icon: "error",
        });
      }

      return false;
    }
  };

  const removeFromWishList = async (): Promise<boolean> => {
    try {
      const response: any = await OrderApiService.removeFromWishlist(wishListRequest);
      return true;
    } catch (error) {
      console.error("Error while removing wishlist data:", error);
      return false;
    }
  };

  let ageInYears: number | null = null;

  // Use starting age ONLY
  if (hit.age_from != null) {
    ageInYears = Math.floor(hit.age_from);
  }

  const barrelImages: string[] = [
    barrel_1_2_a, barrel_2_3_a, barrel_3_4_a, barrel_4_5_a, barrel_5_6_a,
    barrel_6_7_a, barrel_7_8_a, barrel_8_9_a, barrel_9_10_a, barrel_10_11_a,
    barrel_11_12_a, barrel_12_13_a, barrel_13_14_a, barrel_14_15_a, barrel_15_16_a,
    barrel_16_17_a, barrel_17_18_a, barrel_18_19_a, barrel_19_20_a, barrel_20_21_a,
    barrel_21_22_a, barrel_22_23_a, barrel_23_24_a, barrel_24_25_a, barrel_25_plus_a
  ];
  
  const markMyInterest = async () => {
  
    if(CommonService.isAdmin() || CommonService.isSameCompany(hit?.company_id)) {
      return ;
    }

    const payload = {
      companyId: CommonService.getCompanyId(),
      userId: userId,
      wantedToBuyId: hit?.id,
      customerServiceRequestId: hit?.customer_service_request_id,
      productName: hit?.product_name,
      description: hit?.description,
      mashBill: hit?.mash_bill,
      tentativePrice: hit?.tentative_price,
      proofingMin: hit?.proofing_min,
      proofingMax: hit?.proofing_max,
      ageFrom: hit?.age_from,
      ageTo: hit?.age_to,
      containerType: hit?.container_type,
      interestStatus: "INTERESTED"
    };

    try {
      const response = await Service.markMyInterest(payload);

      CommonService.Toast.fire({
        title:"Mark My Interest added!",
        icon: "success"
      });
      setIsInterested(true);

    } catch (error) {
      console.log(error);
      CommonService.Toast.fire({
        title: "Something went wrong!",
        icon: "error",
      });
    }
  };

 const getAgeIndex = (age: number): number => {
    if (age <= 1) return 0;
    if (age >= 25) return barrelImages.length - 1;
    return age - 1;
  };

  const selectedImage = useMemo(() => {
    if (ageInYears == null) return barrel_25_plus_a;
    return barrelImages[getAgeIndex(ageInYears)];
  }, [ageInYears]);

  //Description Contain Show More and Show Less
  const MAX_LENGTH = 500; // show more limit
  const shortDescription = hit?.description && hit.description.length > MAX_LENGTH
    ? hit.description.substring(0, MAX_LENGTH) + "..." : hit.description;

  const handleEditWantedToBuyRequest = (customerServiceRequestId:any) => {
        history.push(`${CommonService.isUser() ? '/user' : '/master'}` + `/edit-customer-service-request/${customerServiceRequestId}`);
  }
  
 return (
    <>
      {/* Start */}
      <section className={`ProductDetail  mb-0 mt-0 ${CommonService.isAdmin() && "admin-detail__container"}`}>
        {CommonService.isAdmin() && (<div className="header-wrapper">
                    <><div className="d-flex align-items-center gap-2">
                      <div className="back__button" onClick={() => history.goBack()}>
                        <IconButton
                          aria-label="ArrowBackIcon"
                          sx={{ backgroundColor: "#FFF" }}
                        >
                          <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                        </IconButton>
                      </div><Typography
                        variant="h1"
                        gutterBottom
                        className='mb-0'
                        sx={{
                          fontSize: "24px",
                          fontWeight: 700,
                          color: "#242424",
                          lineHeight: "22px",
                        }}
                      >
                        Wanted To Buy
                      </Typography>
                    </div>
                    </>
                  </div>
                  )}
                  <div className='detail-inner'>
        <div className="container my-3">
          <div className="row d-flex mb-5">
            <div className="col-12 col-lg-6 mb-5 mb-lg-0">
              <div className="product__img d-flex justify-content-center">
                <img src={selectedImage} alt="WhiskyBarrelBig" />
                {/* Start (Hide This My Listing On Conditionally) */}
                {CommonService.getCompanyId() == hit.company_id &&
                hit?.customer_service_request_id &&
                CommonService.isUser() && (
                  <>
                  <div className='my-listing-wrapper'>
                  <span className='text'>My Listing</span>
                    <span onClick={(e) => {
                        e.stopPropagation();
                        handleEditWantedToBuyRequest(
                          hit?.customer_service_request_id
                        );
                      }} className="img-wrapper">
                      <Tooltip title="Edit My Listing" arrow>
                        <img
                          src={EditIcon}
                          className="cursor-pointer"
                          alt="EditIcon"
                        />
                      </Tooltip>
                    </span>
                    </div>
                  </>
                )}
                {/* End */}
              </div>
            </div>

                {/* start wanted to buy code here for mark my interest*/}
                <div className="col-12 col-lg-6">
                  
                    <div className="product__info">
                      <div className="product__cart mb-3">
                        <div className="row d-flex flex-wrap justify-content-end align-items-center">

                          <div className="col-auto my-2 my-sm-1 px-1">
                            <div className="price__lable">
                              <CurrencyFormatter
                                amount={hit.tentative_price}
                                locale="en-US"
                                currency="USD"
                              />{" "}
                              / {hit.container_type}
                            </div>
                          </div>

                          <div className="col-auto ms-auto my-2 my-sm-1 px-1">
                            <div className="cart__add--btn d-flex justify-content-end">
                              <Tooltip 
                                title={
                                  CommonService.isAdmin()
                                    ? 'This feature is not available for Super Admins.'
                                    : CommonService.isSameCompany(hit?.company_id)
                                    ? 'This Action is disabled due to My Listing'
                                    : 'Mark My Interest'
                                }
                              >
                                <Button
                                  variant="contained"
                                  sx={{
                                    textTransform: "none",
                                    backgroundColor: isInterested ? "#95CF48" : "#E15A0E",
                                    borderRadius: "100px",
                                    padding: "10px 48px",
                                    height: "42px",
                                    fontSize: "18px",
                                    fontWeight: 700,
                                    color: "#FFF",
                                    "&:hover": {
                                      backgroundColor: isInterested
                                        ? darken("#95CF48", 0.2)
                                        : darken("#E15A0E", 0.2),
                                    },
                                  }}
                                  onClick={() => {
                                    if (!isInterested && !isLoading) {
                                      markMyInterest();
                                    }
                                  }}
                                >
                                  {isInterested ? "Marked as Interested" : "Mark My Interest"}
                                </Button>
                              </Tooltip>

                            </div>
                          </div>

                        </div>
                      </div>

                      {/* TABLE BLOCK */}
                      <TableContainer component={Paper} className={classes.root} sx={{ mt: 3 }}>
                        <Table>
                          <TableBody>
                            <TableRow>
                              <TableCell className={classes.firstColumn}>Mash Bill</TableCell>
                              <TableCell className={classes.secondColumn}>{hit.mash_bill}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className={classes.firstColumn}>Proof</TableCell>
                              <TableCell className={classes.secondColumn}>
                                {CommonService.formatToSingleDecimal(hit.proofing_min)} pf - {CommonService.formatToSingleDecimal(hit.proofing_max)} pf
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className={classes.firstColumn}>Age</TableCell>
                              <TableCell className={classes.secondColumn}>
                                {hit.age_from} years {hit.age_to} years
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className={classes.firstColumn}>Container Type</TableCell>
                              <TableCell className={classes.secondColumn}>{hit.container_type}</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>

                      {/* DESCRIPTION */}
                      <div className="row">
                        <div className="col-12">
                          <Typography variant="h5" sx={{ mb: 1, borderTop: "2px solid #ABABAB" }}>
                            Description
                          </Typography>

                          <Typography variant="body1" gutterBottom>
                            <CKContent content={isExpanded ? hit.description : shortDescription} />
                          </Typography>

                          {hit?.description && hit.description.length > MAX_LENGTH && (
                            <Button
                              variant="text"
                              sx={{
                                padding: 0,
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: "16px",
                                color: "#0a0a09ff",
                                "&:hover": { background: "transparent" },
                              }}
                              onClick={() => setIsExpanded(!isExpanded)}
                            >{isExpanded ? "Show Less" : "Show More"}
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                </div>
              {/* end wanted to buy code here for mark my interest*/}
            </div>
          </div>
        </div>
      </section>
      {/* End */}
    </>
  );
};

const CustomHits = ({ children }) => {
  // Access the search status and results using hooks
  const { status } = useInstantSearch();
  const { hits } = useHits();
  const hasSearched = useRef(false);

  useEffect(() => {
    if (status === "loading" || status === "stalled") {
      return;
    }
    hasSearched.current = true;
  }, [status]);

  const isLoading = status === 'loading' || status === 'stalled';

  if (isLoading) {
    return (
      <Container maxWidth="sm" className="loading-wrapper" sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '2rem' }}>
        {/* You can use either MUI's CircularProgress or React-Bootstrap's Spinner */}
        <CircularProgress color="secondary" />
        <Typography variant="subtitle1" sx={{ fontSize: '20px', fontWeight: 600, color: '#737376', marginTop: '12px' }}>
          Loading Products...
        </Typography>
      </Container>
    );
  }

  if (hasSearched.current && status === "idle" && hits.length === 0) {
    return (
      <Container className="loading-wrapper" sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '2rem' }}>
        <ProductionQuantityLimitsOutlinedIcon sx={{fontSize:80,color:"#333"}}/>
        <Typography variant="h6">Out of Stock</Typography>
        <Typography variant="body1" color="text.secondary">
          This Product is no longer available...
        </Typography>
      </Container>
    );
  }

  return (
    <>
      {React.cloneElement(children, { hits })}
    </>
  );
};

export default WantedToBuyProductDetail;